// /////////////////////////////////////////////////////////////
// [ファイル] layout.ts
// [概要] 画面レイアウトの共通定数。
//        ヘッダー直下の余白と「一覧テーブルを画面の残り高さいっぱいに広げる」
//        ための外枠 / テーブル枠の sx をここに集約する。
//
// 一覧ページの組み立て方
//   <Box sx={PAGE_FILL_SX}>                  … 画面高 - ヘッダーに固定 (背面を縦スクロールさせない)
//     見出し・フィルターなど (高さは成り行き)
//     <Box sx={TABLE_FILL_SX}>               … 残った高さをすべてテーブルへ割り当てる
//       <StandardDataTable ... />
//     </Box>
//   </Box>
// 固定値の引き算 (calc(100vh - 160px) 等) は見出しの折り返しやウィンドウ幅で
// 崩れるため使わないこと。
//
// 外枠は border-box のため、余白は上下を py で、左右を width で取る
//   例) <Box sx={{ ...PAGE_FILL_SX, py: 3, width: '95%', margin: '0 auto' }}>
// p: 3 にすると左右の余白が内側に食い込み、テーブルの横幅が 48px 狭くなる。
// /////////////////////////////////////////////////////////////

// ヘッダー (NavigationBar の Toolbar minHeight 30px) の直下に取る余白。
// App.tsx のコンテンツ上端余白と、各ページの高さ計算の両方で参照する。
export const APP_HEADER_OFFSET = 32;

// 画面高からヘッダー分を引いた、ページ本体に使える高さ
export const PAGE_FILL_HEIGHT = `calc(100vh - ${APP_HEADER_OFFSET}px)`;

// テーブルが潰れて見えなくならないための最低高さ。
// これを下回る小さなウィンドウのときだけ、ページ外枠 (PAGE_FILL_SX) が縦スクロールする。
export const TABLE_MIN_HEIGHT = 300;

// ページの外枠。高さを画面に固定し、通常はテーブル内だけがスクロールする。
// ウィンドウが極端に小さくテーブルが最低高さを割るときだけ、この枠内が縦スクロールする
export const PAGE_FILL_SX = {
  height: PAGE_FILL_HEIGHT,
  boxSizing: 'border-box',
  display: 'flex',
  flexDirection: 'column',
  overflowX: 'hidden',
  overflowY: 'auto',
} as const;

// テーブルの枠。外枠の残り高さをすべて受け取る (最低高さを割る場合のみ外枠がスクロール)
export const TABLE_FILL_SX = {
  flex: 1,
  minHeight: TABLE_MIN_HEIGHT,
  display: 'flex',
  flexDirection: 'column',
} as const;
